'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useBjInfoQuery, useEditFanGradeMutation } from '@module/queries/member/memberQueryHooks';
import useModalStore from '@module/stores/useModalStore';
import catchAllErrors from '@module/utils/catchAllErrors';
import { useEffect, useState } from 'react';
function useGradeTableViewModel(channelId) {
  const $ = _c(54);
  const {
    userInfo
  } = useGetLoginInfoQuery();
  const isMyChannel = channelId === userInfo?.id;
  const {
    pushModal,
    popModal,
    clearModals
  } = useModalStore();
  let t0;
  if ($[0] !== channelId) {
    t0 = {
      userId: channelId,
      info: "media fanGrade adminBjNotice exchange checkEnter bookmark"
    };
    $[0] = channelId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: bjInfoData,
    refetch: refetchBjInfo
  } = useBjInfoQuery(t0);
  const [fanLv5Name, setFanLv5Name] = useState("VIP");
  const [fanLv4Name, setFanLv4Name] = useState("\uB2E4\uC774\uC544");
  const [fanLv3Name, setFanLv3Name] = useState("\uACE8\uB4DC");
  const [fanLv2Name, setFanLv2Name] = useState("\uC2E4\uBC84");
  const [fanLv1Name, setFanLv1Name] = useState("\uBE0C\uB860\uC988");
  const [fanLv5Coin, setFanLv5Coin] = useState("1000");
  const [fanLv4Coin, setFanLv4Coin] = useState("700");
  const [fanLv3Coin, setFanLv3Coin] = useState("500");
  const [fanLv2Coin, setFanLv2Coin] = useState("300");
  const [fanLv1Coin, setFanLv1Coin] = useState("100");
  const [fanLv5ExpDay, setFanLv5ExpDay] = useState(30);
  const [fanLv4ExpDay, setFanLv4ExpDay] = useState(30);
  const [fanLv3ExpDay, setFanLv3ExpDay] = useState(30);
  const [fanLv2ExpDay, setFanLv2ExpDay] = useState(30);
  const [fanLv1ExpDay, setFanLv1ExpDay] = useState(30);
  let t1;
  let t2;
  if ($[2] !== bjInfoData) {
    t1 = () => {
      if (!bjInfoData?.fanGrade) {
        return;
      }
      const lv5Data = bjInfoData.fanGrade.find(_temp);
      const lv4Data = bjInfoData.fanGrade.find(_temp2);
      const lv3Data = bjInfoData.fanGrade.find(_temp3);
      const lv2Data = bjInfoData.fanGrade.find(_temp4);
      const lv1Data = bjInfoData.fanGrade.find(_temp5);
      if (!lv5Data || !lv4Data || !lv3Data || !lv2Data || !lv1Data) {
        return;
      }
      setFanLv5Name(lv5Data.name);
      setFanLv4Name(lv4Data.name);
      setFanLv3Name(lv3Data.name);
      setFanLv2Name(lv2Data.name);
      setFanLv1Name(lv1Data.name);
      setFanLv5Coin(lv5Data.coin);
      setFanLv4Coin(lv4Data.coin);
      setFanLv3Coin(lv3Data.coin);
      setFanLv2Coin(lv2Data.coin);
      setFanLv1Coin(lv1Data.coin);
      setFanLv5ExpDay(Number(lv5Data.expDay));
      setFanLv4ExpDay(Number(lv4Data.expDay));
      setFanLv3ExpDay(Number(lv3Data.expDay));
      setFanLv2ExpDay(Number(lv2Data.expDay));
      setFanLv1ExpDay(Number(lv1Data.expDay));
    };
    t2 = [bjInfoData];
    $[2] = bjInfoData;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== clearModals || $[6] !== pushModal || $[7] !== refetchBjInfo) {
    t3 = () => {
      pushModal({
        type: "CONFIRM_MODAL",
        id: "useGradeTableViewModel",
        options: {
          description: "\uC218\uC815\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
          onClose: () => {
            clearModals();
            refetchBjInfo();
          }
        }
      });
    };
    $[5] = clearModals;
    $[6] = pushModal;
    $[7] = refetchBjInfo;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== popModal || $[10] !== pushModal) {
    t4 = err => catchAllErrors(err.message, () => {
      pushModal({
        type: "CONFIRM_MODAL",
        id: "useGradeTableViewModel",
        options: {
          description: err.message,
          onClose: popModal
        }
      });
    });
    $[9] = popModal;
    $[10] = pushModal;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = {
      onSuccess: t3,
      onError: t4
    };
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const {
    mutate: editFanGrade
  } = useEditFanGradeMutation(t5);
  let t6;
  if ($[15] !== editFanGrade || $[16] !== fanLv1Coin || $[17] !== fanLv1ExpDay || $[18] !== fanLv1Name || $[19] !== fanLv2Coin || $[20] !== fanLv2ExpDay || $[21] !== fanLv2Name || $[22] !== fanLv3Coin || $[23] !== fanLv3ExpDay || $[24] !== fanLv3Name || $[25] !== fanLv4Coin || $[26] !== fanLv4ExpDay || $[27] !== fanLv4Name || $[28] !== fanLv5Coin || $[29] !== fanLv5ExpDay || $[30] !== fanLv5Name || $[31] !== pushModal) {
    t6 = () => {
      const coinValueList = [Number(fanLv1Coin), Number(fanLv2Coin), Number(fanLv3Coin), Number(fanLv4Coin), Number(fanLv5Coin)];
      const isZeroValue = coinValueList.some(_temp6);
      const isInvalidValue = coinValueList.some((value, index) => coinValueList.slice(index + 1).some(higher => value > higher));
      if (isZeroValue || isInvalidValue) {
        pushModal({
          type: "CONFIRM_MODAL",
          id: "useGradeTableViewModel",
          options: {
            description: "\uD558\uD2B8 \uC124\uC815 \uAC1C\uC218\uB97C \uD655\uC778\uD574 \uC8FC\uC138\uC694."
          }
        });
        return;
      }
      editFanGrade({
        fanLv5Name,
        fanLv4Name,
        fanLv3Name,
        fanLv2Name,
        fanLv1Name,
        fanLv5Coin: Number(fanLv5Coin),
        fanLv4Coin: Number(fanLv4Coin),
        fanLv3Coin: Number(fanLv3Coin),
        fanLv2Coin: Number(fanLv2Coin),
        fanLv1Coin: Number(fanLv1Coin),
        fanLv5ExpDay,
        fanLv4ExpDay,
        fanLv3ExpDay,
        fanLv2ExpDay,
        fanLv1ExpDay
      });
    };
    $[15] = editFanGrade;
    $[16] = fanLv1Coin;
    $[17] = fanLv1ExpDay;
    $[18] = fanLv1Name;
    $[19] = fanLv2Coin;
    $[20] = fanLv2ExpDay;
    $[21] = fanLv2Name;
    $[22] = fanLv3Coin;
    $[23] = fanLv3ExpDay;
    $[24] = fanLv3Name;
    $[25] = fanLv4Coin;
    $[26] = fanLv4ExpDay;
    $[27] = fanLv4Name;
    $[28] = fanLv5Coin;
    $[29] = fanLv5ExpDay;
    $[30] = fanLv5Name;
    $[31] = pushModal;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  const handleEditButtonClick = t6;
  let t7;
  if ($[33] !== fanLv1Coin || $[34] !== fanLv1ExpDay || $[35] !== fanLv1Name || $[36] !== fanLv2Coin || $[37] !== fanLv2ExpDay || $[38] !== fanLv2Name || $[39] !== fanLv3Coin || $[40] !== fanLv3ExpDay || $[41] !== fanLv3Name || $[42] !== fanLv4Coin || $[43] !== fanLv4ExpDay || $[44] !== fanLv4Name || $[45] !== fanLv5Coin || $[46] !== fanLv5ExpDay || $[47] !== fanLv5Name) {
    t7 = level => {
      switch (level) {
        case 5:
          {
            return {
              name: fanLv5Name,
              setName: setFanLv5Name,
              coin: fanLv5Coin,
              setCoin: setFanLv5Coin,
              expDay: fanLv5ExpDay,
              setExpDay: setFanLv5ExpDay
            };
          }
        case 4:
          {
            return {
              name: fanLv4Name,
              setName: setFanLv4Name,
              coin: fanLv4Coin,
              setCoin: setFanLv4Coin,
              expDay: fanLv4ExpDay,
              setExpDay: setFanLv4ExpDay
            };
          }
        case 3:
          {
            return {
              name: fanLv3Name,
              setName: setFanLv3Name,
              coin: fanLv3Coin,
              setCoin: setFanLv3Coin,
              expDay: fanLv3ExpDay,
              setExpDay: setFanLv3ExpDay
            };
          }
        case 2:
          {
            return {
              name: fanLv2Name,
              setName: setFanLv2Name,
              coin: fanLv2Coin,
              setCoin: setFanLv2Coin,
              expDay: fanLv2ExpDay,
              setExpDay: setFanLv2ExpDay
            };
          }
        case 1:
          {
            return {
              name: fanLv1Name,
              setName: setFanLv1Name,
              coin: fanLv1Coin,
              setCoin: setFanLv1Coin,
              expDay: fanLv1ExpDay,
              setExpDay: setFanLv1ExpDay
            };
          }
        default:
          {
            return null;
          }
      }
    };
    $[33] = fanLv1Coin;
    $[34] = fanLv1ExpDay;
    $[35] = fanLv1Name;
    $[36] = fanLv2Coin;
    $[37] = fanLv2ExpDay;
    $[38] = fanLv2Name;
    $[39] = fanLv3Coin;
    $[40] = fanLv3ExpDay;
    $[41] = fanLv3Name;
    $[42] = fanLv4Coin;
    $[43] = fanLv4ExpDay;
    $[44] = fanLv4Name;
    $[45] = fanLv5Coin;
    $[46] = fanLv5ExpDay;
    $[47] = fanLv5Name;
    $[48] = t7;
  } else {
    t7 = $[48];
  }
  const getStateByLevel = t7;
  let t8;
  if ($[49] !== bjInfoData || $[50] !== getStateByLevel || $[51] !== handleEditButtonClick || $[52] !== isMyChannel) {
    t8 = {
      bjInfoData,
      isMyChannel,
      getStateByLevel,
      handleEditButtonClick
    };
    $[49] = bjInfoData;
    $[50] = getStateByLevel;
    $[51] = handleEditButtonClick;
    $[52] = isMyChannel;
    $[53] = t8;
  } else {
    t8 = $[53];
  }
  return t8;
}
function _temp6(c) {
  return c < 1;
}
function _temp5(item_3) {
  return item_3.level === 1;
}
function _temp4(item_2) {
  return item_2.level === 2;
}
function _temp3(item_1) {
  return item_1.level === 3;
}
function _temp2(item_0) {
  return item_0.level === 4;
}
function _temp(item) {
  return item.level === 5;
}
export default useGradeTableViewModel;